import * as React from "react";
import type { SVGProps } from "react";
const SvgGazeboIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="m26.027 10.336-9.281-5.215v-.329a2.19 2.19 0 0 0-2.188-2.187h-1.116a2.19 2.19 0 0 0-2.188 2.187v.33l-9.28 5.214a.438.438 0 0 0 .214.819H3.53V22.74h-.112c-.774 0-1.404.63-1.404 1.404v.814c0 .242.196.437.438.437h23.096a.437.437 0 0 0 .438-.437v-.814c0-.774-.63-1.404-1.404-1.404h-.112V11.155h1.343a.437.437 0 0 0 .214-.819m-6.48-.056-3.665-4.465h.312l7.947 4.465zm-1.765 12.46v-3.874H20.4v3.874zm-.875 0h-2.47v-3.874h2.47zm-5.814 0v-3.874h2.47v3.874zm-3.494 0v-3.874h2.62v3.874zm3.494-4.75v-6.835h5.814v6.836zm-1.508-7.71 3.665-4.465h1.5l3.665 4.465zm2.544-5.488c0-.723.59-1.312 1.313-1.312h1.116c.724 0 1.313.589 1.313 1.312v.148h-3.742zm-.323 1.023h.312L8.453 10.28H3.859zm-1.587 5.34v6.836H4.405v-6.836zm-5.814 7.71h2.32v3.875h-2.32zm20.705 5.279v.376H2.89v-.376c0-.292.236-.529.528-.529h21.164c.292 0 .528.237.528.529m-3.834-1.404v-3.874h2.319v3.874zm2.319-4.75h-5.813v-6.835h5.813z"
    />
  </svg>
);
export default SvgGazeboIcon;
